import React from 'react';
import PropTypes from 'prop-types';

export const Visibility = ({ isVisible, children }) => (isVisible ? children : <div />);

Visibility.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired
};